import { useState } from "react";
import { Link } from "react-router-dom";
import logo from "../assets/logo.jpeg";

function Navbar() {
  const [menuOpen, setMenuOpen] =
    useState(false);

  return (
    <nav className="navbar">
      <Link
        to="/"
        className="logo-section">
        <img
          src={logo}
          alt="AGP India Organic"
          className="logo"
        />

        <div className="logo-text">
          <h2>AGP India Organic</h2>

          <span>
            Fresh Organic Farms
          </span>
        </div>

      </Link>
      <div
        className="menu-toggle"
        onClick={() =>
          setMenuOpen(!menuOpen)
        }
      >
        ☰
      </div>

      <div
        className={
          menuOpen
            ? "nav-links active"
            : "nav-links"
        }
      >

        <Link
          to="/"
          onClick={() =>
            setMenuOpen(false)
          }
        >
          Home
        </Link>

        <Link
          to="/whyus"
          onClick={() =>
            setMenuOpen(false)
          }
        >
          Why Us
        </Link>

        <Link
          to="/services"
          onClick={() =>
            setMenuOpen(false)
          }
        >
          Services
        </Link>

        <Link
          to="/products"
          onClick={() =>
            setMenuOpen(false)
          }
        >
          Products
        </Link>

        <Link
          to="/contact"
          onClick={() =>
            setMenuOpen(false)
          }
        >
          Contact
        </Link>
      </div>

    </nav>
  );
}

export default Navbar;